import React from 'react'

import classNames from 'classnames'

import style from './StatusPill.module.css'

function StatusPill({ className, inline = true, status, children, testId }) {
  return (
    <span
      className={classNames(
        style.container,
        style[status],
        className,
        inline && style.inline
      )}
      data-testid={testId}
    >
      {children}
    </span>
  )
}

export default StatusPill
